var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native-web");
var _simpleMarkdown = _interopRequireDefault(require("simple-markdown"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports["default"] = Object.assign({}, _simpleMarkdown["default"].defaultRules.paragraph, {
  react: function react(node, output, state) {
    var _process, _process$env;
    var _useStyles = (0, _styles.useStyles)({
        sharedStyles: state.sharedStyles
      }),
      styles = _useStyles.styles;
    var role = {};
    if (_reactNative.Platform.OS === 'web' && process && !((_process = process) != null && (_process$env = _process.env) != null && _process$env.JEST_WORKER_ID)) {
      role.role = 'paragraph';
    }
    return (0, _jsxRuntime.jsx)(_reactNative.Text, Object.assign({
      style: [styles.container, state.containerStyle],
      textBreakStrategy: "simple"
    }, role, state.extraProps, {
      children: (0, _jsxRuntime.jsx)(_reactNative.Text, {
        textBreakStrategy: "simple",
        style: [styles.text, state.textStyle],
        nativeID: state.nativeID,
        children: output(node.content, Object.assign({}, state, {
          contentCount: node.content.length
        }))
      })
    }), state.key);
  },
  match: _simpleMarkdown["default"].blockRegex(/^((?:[^\n]|\n(?! *\n))+?)(?:\n *?)+(?:\n|(?=#))/)
});